<template>
  <div class="wrap">
    <div class="item-list">
      <div
        v-for="item in sortList"
        :key="item.user"
        class="item"
      >
        <div class="index">{{ item.sort }}</div>
        <el-tooltip :content="item.user" placement="top">
          <Avatar 
            :font="item.name" 
            color="#1890FF" 
            background="#e4f1ff" 
            fontSize="12" 
            size="36" 
            class="avatar"
          />
        </el-tooltip>
        <div class="name">{{ item.formatName }}</div>
        <div class="time-avg">{{ item.approvalTimeAvgFormate }}</div>
        <div class="likes" >
          <i
            class="iconfont icondianzan-highlight"
            :class="{ 'like-contain-self': item.isContainSelf }"
            @click.stop="like(item)"
          ></i>
          <span class="likes-num"> {{ item.likes }}</span>
        </div>
      </div>
    </div>

    <!-- 我的排名 -->
    <div v-if="!mySortInfo.isNull" class="item self-sort-item">
      <div class="my-sort">
        <span class="sort-prefix">我的排名</span>
        <span class="sort-num">第 {{ mySortInfo.sort }} 名</span>
      </div>
      <div class="time-avg">{{ mySortInfo.approvalTimeAvgFormate }}</div>
      <div class="likes">
        <i
          class="iconfont icondianzan-highlight"
          :class="{ 'like-contain-self': mySortInfo.isContainSelf }"
        ></i>
        <span class="likes-num">{{ mySortInfo.likes }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    sortList: {
      type: Array,
      default() {
        return 
      },
    },
    mySortInfo: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapState("base", {
      userInfo: "userInfo",
    })
  },
  methods: {
    like(item, index) {
      if (this.userInfo.emailPrefix === item.user) return
      this.$emit('like', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  .item-list {
    height: 310px;
    overflow-y: scroll;
    &::-webkit-scrollbar-thumb { 
      border-radius: 3px; 
      height: 64px;
    }
  }
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .index {
      font-size: 14px;
      color: #bfbfbf;
      width: 45px;
      padding-left: 10px;
    }
    .avatar {
      margin-top: 4px;
    }
    .name {
      font-size: 14px;
      color: #303133;
      margin-left: 14px;
    }
    .time-avg {
      flex: 1;
      text-align: right;
      font-size: 14px;
      color: #606266;
      line-height: 20px;
      padding-right: 30px;
    }
    .likes {
      width: 50px;
      margin-left: 8px;
      line-height: 16px;
      .icondianzan-highlight {
        color: #CED2DD;
        cursor: pointer;
        font-size: 16px;
        vertical-align: middle;
        &.like-contain-self {
          color: #ff8f80;
        }
        &:hover {
          opacity: 0.7;
        }
      }
      .likes-num {
        font-size: 12px;
        color: #909399;
        line-height: 12px;
        margin-left: 6px;
      }
    }
    .my-sort {
      .sort-prefix {
        margin: 0 8px;
        font-size: 12px;
        color: #909399;
        line-height: 14px;
      }
      .sort-num {
        font-size: 12px;
        color: #303133;
        line-height: 20px;
        font-weight: 500;
      }
    }
  }
  .self-sort-item {
    margin-top: 15px;
    margin-bottom: 0;
    padding: 5px 0;
    background: #f7fafa;
    border-radius: 2px;
    border-radius: 2px;
  }
}
</style>
